import { render, staticRenderFns } from "./QnCompany.vue?vue&type=template&id=7f21bd0e&scoped=true&"
import script from "./QnCompany.vue?vue&type=script&lang=js&"
export * from "./QnCompany.vue?vue&type=script&lang=js&"
import style0 from "./QnCompany.vue?vue&type=style&index=0&id=7f21bd0e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f21bd0e",
  null
  
)

export default component.exports